import React, { memo } from 'react'
import { Trans } from 'react-i18next'
import { Card, Stack } from '@mui/material'

import SubmitButton from '../shared/button/SubmitButton'
import CardHeading from '../shared/text/CardHeading'
import { buildKYCStatus } from '../../util/kyc.helpers'
import KYCAlert from './KYCAlert'
import RefreshButton from '../shared/button/RefreshButton'
import brandConfig from 'brandConfig'

const KYCInfo = ({
  t,
  onContinueKYC,
  kycProfile: { id, status, isProcessing, isRefreshing },
  onRefreshKYC
}) => {
  const { severity, title, icon, support, disabled, hide, refresh } =
    buildKYCStatus({ id, status })
  return (
    <Card
      sx={{
        p: 3
      }}
    >
      <CardHeading
        title={t('kyc.kyc-info')}
        desc={
          <Trans
            i18nKey='kyc.unlock-more-features'
            values={{ name: brandConfig.name }}
          />
        }
      />
      <KYCAlert
        t={t}
        severity={severity}
        icon={icon}
        title={title}
        support={support}
      />
      {(!hide || refresh) && (
        <Stack
          mt={3}
          alignItems='flex-end'
          direction='row'
          justifyContent='end'
          spacing={2}
        >
          {refresh && (
            <RefreshButton
              t={t}
              onClick={onRefreshKYC}
              loading={isRefreshing}
            />
          )}
          {!hide && (
            <SubmitButton
              type='button'
              size='default'
              label={t('kyc.complete-kyc')}
              onClick={onContinueKYC}
              loading={isProcessing}
              disabled={disabled}
            />
          )}
        </Stack>
      )}
    </Card>
  )
}

export default memo(KYCInfo)
